import { useQuery } from '@apollo/client';
import { graphql } from '../gql';

export const GET_RESERVES = graphql(`
  query getReserves($claimUuid: String) {
    reserves(filters: { claimUuid: $claimUuid }) {
      pageInfo {
        totalResults
      }
      edges {
        node {
          uuid
          tenant
          totalIncurred
          paymentTotal
          remainingReserve
          payments {
            edges {
              node {
                uuid
                message
                reserveAmount
                retentionAmount
                attachments {
                  edges {
                    node {
                      uuid
                      targetType
                      targetName
                      targetUuid
                      dataSource
                      filePath
                      folder
                      createdAt
                      updatedAt
                      url
                    }
                  }
                }
                invoiceNumber
                paidAt
                createdAt
                tenant
                type
                status
                expenseType {
                  name
                  uuid
                  coverage {
                    name
                    uuid
                    subCoverage {
                      name
                      uuid
                    }
                  }
                  subExpenseType {
                    name
                    uuid
                    coverage {
                      name
                      uuid
                      subCoverage {
                        name
                        uuid
                      }
                    }
                  }
                }
                lossType {
                  name
                  uuid
                  coverage {
                    name
                    uuid
                    subCoverage {
                      name
                      uuid
                    }
                  }
                }
                insured {
                  node {
                    uuid
                    aliases(filters: { source: PRIMARY, type: LEGAL_NAME }) {
                      edges {
                        cursor
                        queryCursor
                        node {
                          uuid
                          name
                          type
                          sources
                          primary
                        }
                      }
                    }
                  }
                }
                claimant {
                  node {
                    uuid
                    firstName
                    lastName
                  }
                }
                vendor {
                  node {
                    uuid
                    aliases(filters: { source: PRIMARY, type: LEGAL_NAME }) {
                      edges {
                        cursor
                        queryCursor
                        node {
                          uuid
                          name
                          type
                          sources
                          primary
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          reserveType {
            uuid
            name
          }
        }
      }
    }
  }
`);
export interface IUseReservesQueryArg {
  claimUuid?: string;
}

export function useReservesQuery({ claimUuid }: IUseReservesQueryArg) {
  const { loading, data, error } = useQuery(GET_RESERVES, {
    variables: {
      claimUuid,
    },
  });

  return {
    loading,
    error,
    data,
  };
}
